import { useMemo } from 'react';
import type { MetricsStore } from '.';
import type { MetricType } from './types';

export function useLatestMetrics(store: MetricsStore, type: MetricType) {
  return useMemo(() => {
    const metrics = store.state.data[type] || [];

    return [...metrics].sort(
      (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
    );
  }, [store.state.data, type]);
}

export function useMetricsByDateRange(
  store: MetricsStore,
  type: MetricType,
  startDate: Date,
  endDate: Date,
) {
  return useMemo(() => {
    const metrics = store.state.data[type] || [];

    return metrics.filter((metric) => {
      const date = new Date(metric.date);

      return date >= startDate && date <= endDate;
    });
  }, [store.state.data, type, startDate, endDate]);
}
